import React, {Component} from 'react';
import SidebarMenuRouters from "../../routers/routers.js";
import Header from '../../containers/header.js';
import Panel from '../../components/panel.js';

import PotentialBillingIncreaseComponent from "../../components/potentialBillingIncreaseComponent";
import AccumulatedOptimizationCategoriesComponent from "../../components/accumulatedOptimizationCategoriesComponent";
import AccountsIdentifiedForOptimizationComponent from "../../components/accountsIdentifiedForOptimizationComponent";
import {Redirect} from 'react-router';
import {ROL} from '../../utils/constants';
import SurfaceDifference from "../../components/tables/SurfaceDifference";
import UseDifference from "../../components/tables/UseDifference";

class OptimizationMonitoring extends Component {
  constructor(props) {
    super(props);
    var userData = JSON.parse(localStorage.getItem("userData"));
    this.state = {userData: userData}
  }


  render() {
    var result;
    result = <div>
      <SidebarMenuRouters profile="/operation-home/" place={this.props.match.params.vp}
      />
      <Header userName={this.state.userData.name} title={"Monitoreo de optimización"}/>
      <div className="grid-data-dash">
        <div className="row">
          <div className="offset-1 col-sm-10 col-md-10">
            <Panel title="Cuentas con diferencia de metros cuadrados" righticon={false}>
              <SurfaceDifference striped={true} bordered={true} bu={this.props.match.params.vp}/>
            </Panel>
          </div>
        </div>
        <div className="row">
          <div className="offset-1 col-sm-10 col-md-10">
            <Panel title="Cuentas con diferencias de uso" righticon={false}>
              <UseDifference striped={true} bordered={true} bu={this.props.match.params.vp}/>
            </Panel>
          </div>
        </div>
        <div className="row">
          <div className="offset-1 col-sm-10 col-md-10">
            <Panel title="Valor incrementado de cuentas con optimización" righticon={false}>
              <PotentialBillingIncreaseComponent bu={this.props.match.params.vp}/>
            </Panel>
          </div>
        </div>
      </div>
    </div>
    return (
      <div>
        {result}
      </div>
    );
  }
}

export default OptimizationMonitoring;



// WEBPACK FOOTER //
// ./src/scene/operation/optimizationMonitoring.js